import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import IDODevHero from "./IDODevHero";
import IDODevSer from "./IDODevSer";
import RigorouSecurity from "./RigorouSecurity";
import OurIDODevPro from "./OurIDODevPro";
import WhyChooseXeer from "../../DeFi/DeFiStaking/WhyChooseXeer";

function IDODevelopment() {
  return (
    <div>
      <Header />
      <IDODevHero />
      <IDODevSer />
      <RigorouSecurity />
      <OurIDODevPro />
      <WhyChooseXeer />
      <Footer />
    </div>
  );
}

export default IDODevelopment;
